import React from 'react'
import Svg from './Svg'
export const SvgPencil = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M20.25 0a3.75 3.75 0 013 6l-1.5 1.5-5.25-5.25L18 .75A3.73 3.73 0 0120.25 0zM1.5 17.25L0 24l6.75-1.5L20.625 8.625l-5.25-5.25L1.5 17.25zm15.271-8.728l-10.5 10.5-1.293-1.293 10.5-10.5 1.293 1.293z" />
  </Svg>
))
SvgPencil.isIcon = true
export default SvgPencil
